import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import './CityPages.css';
import {
  YS7_IFRAME_PLAYER,
  YS7_ACCESS_TOKENS,
  JINGHONG_DEVICE_SERIAL,
  JINGHONG_CHANNELS,
  LINSHUI_DEVICE_SERIAL,
  LINSHUI_LIVE_CHANNELS,
  LINSHUI_OFFLINE_CHANNELS,
} from '../../config/videoMonitorConfig';

const getCityDisplayName = (slug) => {
  const map = { linshui: '邻水', jinghong: '景洪' };
  return map[slug] || slug;
};

function buildYs7IframeSrc(deviceSerial, channel, accessToken) {
  const ezUrl = `ezopen://open.ys7.com/${encodeURIComponent(deviceSerial)}/${encodeURIComponent(channel)}.hd.live`;
  const params = new URLSearchParams({ url: ezUrl, autoplay: '1', audio: '1', accessToken });
  return `${YS7_IFRAME_PLAYER}?${params.toString()}`;
}

const VideoMonitor = () => {
  const { city } = useParams();
  const cityName = getCityDisplayName(city);

  const jinghongGrid = useMemo(() => {
    const token = YS7_ACCESS_TOKENS.jinghong;
    return JINGHONG_CHANNELS.map((ch) => ({
      key: `jh-${ch}`,
      title: `通道 ${ch}`,
      src: buildYs7IframeSrc(JINGHONG_DEVICE_SERIAL, ch, token),
    }));
  }, []);

  /** 邻水：1、3、10 在线；2、5 按 log.ipynb 占位（曾无法接入） */
  const linshuiGrid = useMemo(() => {
    const token = YS7_ACCESS_TOKENS.linshui;
    const liveSet = new Set(LINSHUI_LIVE_CHANNELS);
    const offlineSet = new Set(LINSHUI_OFFLINE_CHANNELS);
    const order = ['1', '2', '3', '5', '10'];
    return order.map((ch) => {
      const offline = offlineSet.has(ch);
      const live = liveSet.has(ch);
      return {
        key: `ls-${ch}`,
        title: `通道 ${ch}${offline ? '（待接入）' : ''}`,
        src: live ? buildYs7IframeSrc(LINSHUI_DEVICE_SERIAL, ch, token) : '',
        offline,
      };
    });
  }, []);

  const videoGridStyle = (cols) => ({
    display: 'grid',
    gridTemplateColumns: `repeat(${cols}, 1fr)`,
    gridAutoRows: 'minmax(140px, 1fr)',
    gap: '8px',
    width: '100%',
    height: 'calc(100vh - 220px)',
    minHeight: 320,
  });

  return (
    <div className="city-page">
      <Navbar />
      <main className="city-main">
        <div className="city-container">
          <h1 className="city-title">{cityName} · 视频监控</h1>
          <div className="city-card video-area">
            {city === 'jinghong' ? (
              <div style={videoGridStyle(4)}>
                {jinghongGrid.map((item) => (
                  <div
                    key={item.key}
                    style={{ position: 'relative', background: '#000', borderRadius: '8px', overflow: 'hidden' }}
                  >
                    {item.src ? (
                      <iframe
                        title={`jinghong-ys7-${item.key}`}
                        src={item.src}
                        allow="autoplay"
                        frameBorder="0"
                        style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                      />
                    ) : null}
                    <div
                      style={{
                        position: 'absolute',
                        bottom: 4,
                        left: 6,
                        color: '#ddd',
                        fontSize: 12,
                        textShadow: '0 0 4px #000',
                        pointerEvents: 'none',
                      }}
                    >
                      {item.title}
                    </div>
                  </div>
                ))}
              </div>
            ) : city === 'linshui' ? (
              <div style={videoGridStyle(3)}>
                {linshuiGrid.map((item) => (
                  <div
                    key={item.key}
                    style={{ position: 'relative', background: '#000', borderRadius: '8px', overflow: 'hidden' }}
                  >
                    {item.src ? (
                      <iframe
                        title={`linshui-ys7-${item.key}`}
                        src={item.src}
                        allow="autoplay"
                        frameBorder="0"
                        style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                      />
                    ) : (
                      <div
                        style={{
                          position: 'absolute',
                          inset: 0,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          color: '#888',
                          padding: 12,
                          textAlign: 'center',
                        }}
                      >
                        {item.title}
                        <br />
                        <span style={{ fontSize: 12, marginTop: 8 }}>log.ipynb：2/5 路曾无法接入，修好萤石后可去掉占位</span>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            ) : (
              <>
                <video src="/videos/promo.mp4" controls preload="metadata" poster="/images/background.jpg" />
                <p className="muted">此处为视频监控占位内容。后续可接入实时流地址或多路监控布局。</p>
              </>
            )}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default VideoMonitor;
